import { render, staticRenderFns } from "./widget-compare.vue?vue&type=template&id=5a88091c&"
import script from "./widget-compare.vue?vue&type=script&lang=js&"
export * from "./widget-compare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5a88091c', component.options)
    } else {
      api.reload('5a88091c', component.options)
    }
    module.hot.accept("./widget-compare.vue?vue&type=template&id=5a88091c&", function () {
      api.rerender('5a88091c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/page-part/widget-compare.vue"
export default component.exports